module.exports = __webpack_public_path__ + "img/HPS009CP.1748065a.png";